module.exports = __webpack_public_path__ + "static/media/chevronRightDouble.65ea7657.svg";